import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../turkeydrop/turkeydrop2025/turkeydrop2025.css";
import ShieldIMG from "../../assets/rhp-shield.png";

const DONATE_URL = "https://give.rush.edu/campaign/694982/donate";

function buildInternalLink(pathname, search) {
  return {
    pathname,
    search: search || "",
  };
}

export default function PintsSunsetPage({ event }) {
  const location = useLocation();

  useEffect(() => {
    document.title = event?.title || "Pints for Patriots";
  }, [event?.title]);

  const chowCallLink = buildInternalLink("/chow-call-vfw981", location.search);
  const pintsLink = buildInternalLink("/pints-for-patriots", location.search);

  return (
    <main className="tdp-shell">
      <div
        className="tdp-bg"
        style={{ "--bg-url": `url(${ShieldIMG})` }}
        aria-hidden="true"
      />

      <section className="tdp-left">
        <span className="crumb">Road Home Program Fundraiser</span>
        <h1 className="tdp-title">{event?.title || "Pints for Patriots"}</h1>
        <p className="tdp-sub" style={{ maxWidth: 680 }}>
          This Pints for Patriots location event has concluded. Thank you for supporting the Road
          Home Program.
        </p>
      </section>

      <section className="tdp-right">
        <article className="tdp-card">
          <p
            style={{
              margin: 0,
              fontSize: 12,
              letterSpacing: ".08em",
              textTransform: "uppercase",
              color: "#2f6b49",
              fontWeight: 700,
            }}
          >
            Event Concluded
          </p>
          <h2 className="tdp-card-title" style={{ marginTop: 10 }}>
            Thank you for supporting the Road Home Program.
          </h2>
          <p className="tdp-card-sub" style={{ marginBottom: 16 }}>
            RSVPs for this location are now closed.
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
            <a
              className="tdp-submit"
              href={DONATE_URL}
              target="_blank"
              rel="noreferrer"
              style={{ display: "inline-flex" }}
            >
              Donate to Road Home
            </a>
            <Link className="tdp-ghost-btn" to={chowCallLink} style={{ textDecoration: "none" }}>
              See Our Next Event: Chow Call
            </Link>
          </div>
          <p style={{ marginTop: 18 }}>
            <Link to={pintsLink}>Back to Pints for Patriots</Link>
          </p>
        </article>
      </section>
    </main>
  );
}
